const icons = {
    'checkmark-green': { name: 'checkmark-circle-fill', category: 'interface', color: 'green' },
    'warning-yellow': { name: 'warning-circle-fill', category: 'interface', color: 'orange' },
    'warning-red': { name: 'warning-diamond-filled', category: 'interface', color: 'red' },
    'info-grey': { name: 'info-filled', category: 'interface', color: 'grey-450' },
    'update-grey': { name: 'refresh', category: 'arrows', color: 'grey-450' }
};

const statusToIcon = {
    'OPERATIONAL': 'checkmark-green',
    'RESOLVED': 'checkmark-green',
    'UPDATED': 'update-grey',
    'GREY': 'info-grey',
    'YELLOW': 'warning-yellow',
    'RED': 'warning-red',
    'maintenanceMessage': 'info-grey'
};

export { icons, statusToIcon }
